/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { TitleRow } from './appNavBits/AppNavRow';

const AppNavTitleRow = (props) => (
  <TitleRow alignItems="flex-end">
    <FormattedMessage {...props.phraseData} />
    {props.children}
  </TitleRow>
);
AppNavTitleRow.propTypes = {
  phraseData: PropTypes.object,
  children: PropTypes.any,
};

export default AppNavTitleRow;
